import { GetDepositData } from "./GetDepositData";
import { GetPensionData } from "./GetPensionData";
import { GetAmitRedemptionRights } from "./GetAmitRedemptionRights";
import { GetRightsPerEmpJob } from "./GetRightsPerEmpJob";
import { GetSalaryData } from "./GetSalaryData";


export async function GetDashboradData() {
    return Promise.all([
        GetPensionData(),
        GetAmitRedemptionRights(),
        GetRightsPerEmpJob(),
        GetSalaryData(),

    ])
}
